import { IColumnDefinition } from '@nx-monorepo/cms-base/interfaces';

export const kontaktColumnDefinitions: IColumnDefinition[] = [
  {
    title: 'select',
    key: ['select'],
    type: 'select',
    sortable: false,
    align: 'left',
    fxHide: {
      sm: false,
      md: false,
      lg: false
    }
  },
  {
    title: 'ID',
    key: ['id'],
    type: 'string',
    sortable: true,
    shrink: true,
    align: 'left',
    fxHide: {
      sm: false,
      md: false,
      lg: false
    }
  },
  {
    title: 'Název',
    key: ['nazev'],
    type: 'string',
    sortable: true,
    align: 'left',
    fxHide: {
      sm: false,
      md: false,
      lg: false
    }
  },
  {
    title: 'IČO',
    key: ['ico'],
    type: 'string',
    sortable: true,
    align: 'left',
    fxHide: {
      sm: false,
      md: false,
      lg: false
    }
  }
];
